import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@wehunt/core-web'
import type { GroupPhoto } from '@wehunt/ui'
import { useApiFetch } from '../../shared/api'

interface GroupPhotosResponse {
  photos: GroupPhoto[]
  /**
   * True when the team has more camera media than `photos` carries. The gallery
   * says so rather than presenting a subset as the whole: an arbitrary slice
   * shown as complete is how entire cameras went missing unnoticed.
   */
  truncated: boolean
}

export function useGroupPhotos(groupId: string) {
  const call = useApiFetch()
  const { state } = useAuth()
  const uid = state.status === 'signed-in' ? state.user.uid : undefined
  return useQuery({
    queryKey: ['clubhouse', 'groups', groupId, 'photos'],
    queryFn: () => call<GroupPhotosResponse>(`/clubhouse/groups/${groupId}/photos`),
    enabled: !!uid && !!groupId,
    staleTime: 2 * 60 * 1000,
  })
}
